import type * as React from 'react';

type HeaderType = {
  startFirstColumn?: boolean;
};

const CommonHeaderStyles =
  'row-start-1 col-end-3 flex justify-between items-center';

export const HeaderContainer: React.FunctionComponent<HeaderType> = ({
  children,
  startFirstColumn,
}) => {
  return (
    <div
      className={`${CommonHeaderStyles} pr-1 row-end-3 col-start-1 sm:row-end-2 ${
        startFirstColumn ? '' : 'sm:col-start-2'
      } overflow-hidden`}
    >
      {children}
    </div>
  );
};

export const PreviewSourceHeaderContainer: React.FunctionComponent = ({
  children,
}) => {
  return (
    <div
      className={`${CommonHeaderStyles} pr-4 sm:pr-6 row-end-2 col-start-2 overflow-hidden`}
    >
      {children}
    </div>
  );
};
